module.exports = __webpack_public_path__ + "img/cycling-2.fffbd37a.svg";